var map = {
	"./adult1.inline.svg": 23730,
	"./appercot.svg": 21188,
	"./architectureicon.inline.svg": 28267,
	"./atoms_title.svg": 4147,
	"./audit.inline.svg": 2462,
	"./baby1.inline.svg": 7422,
	"./brandbook.inline.svg": 22989,
	"./branding1.inline.svg": 41479,
	"./chaticon1.inline.svg": 31415,
	"./designsystemicon.inline.svg": 71159,
	"./discoveryandresearchicon01.inline.svg": 55289,
	"./documenticon.inline.svg": 75185,
	"./expertreview.inline.svg": 5265,
	"./gfgsfgfs-1.svg": 39813,
	"./illustrations.inline.svg": 98638,
	"./logo.inline.svg": 63190,
	"./logo_free-ukraine.svg": 18056,
	"./migis.svg": 42263,
	"./mobileappicon.inline.svg": 18609,
	"./mobileappicon.svg": 21838,
	"./responsive.inline.svg": 14311,
	"./rocketicon01.inline.svg": 40247,
	"./sass.inline.svg": 7863,
	"./uxdesignicon01.inline.svg": 49828,
	"./uxstrategyandideationicon01.inline.svg": 61259,
	"./web.inline.svg": 10647,
	"./yangol.svg": 99824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51873;